import { isRSAA, RSAA } from 'redux-api-middleware';

const createClientContextMiddleware = (clientContext) => () => (next) => (action) => {
  if (!isRSAA(action)) {
    return next(action);
  }

  return next({
    ...action,
    [RSAA]: {
      ...action[RSAA],
      headers: {
        ...action[RSAA].headers,
        'x-bpi-client-context': JSON.stringify(clientContext)
      }
    }
  });
};

export default createClientContextMiddleware;
